import classNames from 'classnames';
import { ForwardedRef, HTMLAttributes, ReactNode } from 'react';

import styles from '../../styles/themes/bnc-fraude-theme.module.css';

interface BncFraudeThemeProps extends HTMLAttributes<HTMLDivElement> {
    className?: string | null;
    children: ReactNode;
}

function BncFraudeTheme({
    children,
    className = null,
    ref = null,
    ...props
}: BncFraudeThemeProps & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    return (
        <div className={classNames([className, styles.container])} ref={ref} {...props}>
            {children}
        </div>
    );
}

export default BncFraudeTheme;
